function getIsSubscriptionExpired (endsAt) {
  return !!endsAt && new Date(+endsAt) < new Date();
}

module.exports = getIsSubscriptionExpired;
